import { render, staticRenderFns } from "./MpFindWords02V2.vue?vue&type=template&id=dbaeed2e&scoped=true&"
import script from "./MpFindWords02V2.vue?vue&type=script&lang=js&"
export * from "./MpFindWords02V2.vue?vue&type=script&lang=js&"
import style0 from "./MpFindWords02V2.vue?vue&type=style&index=0&id=dbaeed2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaeed2e",
  null
  
)

export default component.exports